import React from 'react';

import ExternalPageModal from './ExternalPageModal';

export default function RevenueExternalPageModal() {
  return (
    <ExternalPageModal message="Follow all the steps and provide the necessary information to set up your revenue account." />
  );
}
